// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4) return "main." + __webpack_require__.h() + ".css";
	// return url for filenames based on template
	return "" + ({"0":"ang-search","1":"asset-versions-metrics","2":"client-applications","3":"client-applications-deprecated","5":"page-editor","6":"publish-form-v1","7":"publish-form-v2","8":"settings","9":"top-rank-metrics"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".css";
};